<template>
  <div class="entity" v-bind:class="{'form-disabled':isDisabled}">

    <ModalPersonEdit v-model="newEntity"
                     v-if="isModalPersonEditVisible"
                     :is-modal="true"
                     @close="closeModal"
                     @validate="validateModalPersonEdit"/>

    <ModalCompanyEdit v-model="newEntity"
                      v-if="isModalCompanyEditVisible"
                      :is-modal="true"
                      @close="closeModal"
                      @validate="validateModalCompanyEdit"/>

    <ModalDetail v-model="detailEntity"
                 v-if="isModalDetailVisible"
                 @close="closeModal"
                 @validate="closeModal"/>

    <form-checklist :default="defaultChecklist" v-model="type" :options="types" multiple="false"
                    v-show="showCompanyVue" :disabled="isDisabled"></form-checklist>
    <form-autocomplete :label="labelTxt" multiple="false" v-model="person" :default="person_id" :service="personService"
                       :callback="selectPerson" :create="newCustomer" :display-create="onCreate" :detail="showCustomer"
                       :display-detail="onDetail" icon="icon-icon_person" v-if="type[0] == 'person'"
                       :disabled="isDisabled"></form-autocomplete>
    <form-autocomplete :label="labelTxt" multiple="false" v-model="company" :default="company_id"
                       :service="companyService" :callback="selectCompany" :create="newCustomer"
                       :display-create="onCreate" :detail="showCustomer" :display-detail="onDetail"
                       icon="icon-icon_company" v-if="type[0] == 'company'" :disabled="isDisabled"></form-autocomplete>

  </div>
</template>

<script>

import PersonService from '../modules/person/PersonService.js';
import CompanyService from '../modules/company/CompanyService.js';

import ModalCompanyEdit from '../modules/company/Edit.vue'
import ModalPersonEdit from '../modules/person/Edit.vue'

import ModalDetail from '../modules/person/ModalDetail.vue'

export default {
  name: 'Entity',
  props: ['value', 'locale', 'callback', 'default', 'defaultType', 'showCompany', 'showCreate', 'showDetail', 'label', 'disabled'],
  components: {
    ModalCompanyEdit,
    ModalPersonEdit,
    ModalDetail
  },
  data: function () {
    return {
      config: {},
      defaultChecklist: null,
      isModalCompanyEditVisible: false,
      isModalPersonEditVisible: false,
      isModalDetailVisible: false,
      newEntity: null,
      detailEntity: null,
      entity: null,
      person: null,
      person_id: null,
      company: null,
      company_id: null,
      internalValue: [],
      locales: null,
      selectedLang: null,
      treated: false,
      types: [
        {id: 'person', name: 'Individu'},
        {id: 'company', name: 'Entreprise'}
      ],
      type: 'person',
      addresses: null,
      onCreate: null,
      companyService: null,
      personService: null,
      showCompanyVue: true
    }
  },
  created: function () {

    this.internalValue = this.value;
    this.selectedLang = this.locale;
    this.locales = this.$store.state.scope.locales;
    this.onCreate = this.showCreate && (this.showCreate != 'false' || this.showCreate != false) ? true : false;
    this.onDetail = this.showDetail && (this.showDetail != 'false' || this.showDetail != false) ? true : false;
    this.onChange = this.callback ? true : false;
    this.showCompanyVue = this.showCompany == false ? 0 : 1;
    this.labelTxt = this.label ? this.label : "client"
    this.setDisabled(this.disabled)

    this.companyService = CompanyService;
    this.personService = PersonService;

    if (this.default !== undefined && this.default !== null) {
      this.setDefault(this.default);
    }

    /*
    this.setDefault(this.default);

    this.unWatchDefault = this.$watch('default', function(newVal, oldVal) {
        if( newVal != oldVal )
        {
            this.setDefault(newVal);
        }
    });
    */

  },
  methods: {
    setDefault: function (value) {

      console.log('[[[[[[[[[[  setDefault', value, this.defaultType);

      if (this.defaultType !== undefined && this.defaultType !== null) {
        this.type = this.defaultType.toLowerCase().indexOf("company") >= 0 ? "company" : this.type;
      }


      if (value) {
        this.defaultChecklist = this.type;

        if (this.type == 'person') {
          this.selectPerson({id: value});
        } else if (this.type == 'company') {
          this.selectCompany({id: value});
        }

        if (this.unWatchDefault) {
          this.unWatchDefault();
        }
      }
    },
    newCustomer: function () {

      this.newEntity = {
        isModal: true
      };

      if (this.type.indexOf('person') >= 0) {
        this.isModalPersonEditVisible = true;
        this.isModalCompanyEditVisible = false;
      } else {
        this.isModalCompanyEditVisible = true;
        this.isModalPersonEditVisible = false;
      }

    },
    showCustomer: function () {
      this.detailEntity = this.internalValue.entity
      this.isModalDetailVisible = true;
    },
    selectPerson: function (person) {
      //console.log('selectPerson', person.id);

      let self = this;
      this.addresses = [];

      if (person.id !== undefined) {
        this.personService.get(person.id).then(function (response) {
          //console.log("Person", response.data);

          self.entity = response.data;

          self.linkAdresses(response.data.addresses);
          self.internalValue = {
            type: self.type[0],
            entity: self.entity,
            addresses: self.addresses
          }

          if (self.person == null) {
            self.person = response.data
          }

        });
      } else {
        self.internalValue = {}
      }
    },
    selectCompany: function (company) {
      let self = this;
      this.addresses = [];
      if (company.id !== undefined) {
        this.companyService.get(company.id).then(function (response) {
          //console.log("Company", response.data);
          self.entity = response.data;
          self.linkAdresses(response.data.addresses);
          self.internalValue = {
            type: self.type[0],
            entity: self.entity,
            addresses: self.addresses
          }

          if (self.company == null) {
            self.company = response.data
          }
        });
      } else {
        self.internalValue = {}
      }
    },
    linkAdresses: function (addresses) {

      this.addresses = []

      for (let item of addresses) {
        item = Object.assign(item, {
          name: (item.company ? item.company + ", " : "") + item.firstname + " " + item.lastname,
          description: item.street + ", " + item.postal_code + " " + item.locality + ", " + item.country_id
        });
        this.addresses.push(item);
      }

      if (this.addresses.length) {
        //this.resource.address_billing = this.addresses[0]
      }
    },
    closeModal() {
      this.isModalPersonEditVisible = false;
      this.isModalCompanyEditVisible = false;
      this.isModalDetailVisible = false;
    },
    validateModalPersonEdit(model) {

      var self = this;

      this.personService.get(model.id).then(function (response) {
        //console.log("Person", response.data);

        self.entity = response.data;

        self.linkAdresses(response.data.addresses);
        self.internalValue = {
          type: self.type[0],
          entity: self.entity,
          addresses: self.addresses
        }

        self.person = self.entity
      });

      this.closeModal()
    },
    validateModalCompanyEdit(model) {

      var self = this;

      this.companyService.get(model.id).then(function (response) {
        //console.log("Person", response.data);

        self.entity = response.data;

        self.linkAdresses(response.data.addresses);
        self.internalValue = {
          type: self.type[0],
          entity: self.entity,
          addresses: self.addresses
        }

        self.company = self.entity
      });

      this.closeModal()
    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      this.internalValue = newVal
    },
    'default'(newVal, oldVal) {
      if (newVal !== undefined && newVal !== oldVal) {
        this.setDefault(newVal);
      }
    },
    'internalValue'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('input', this.internalValue);
        if (this.onChange) {
          this.callback(this.internalValue)
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Entity.vue